import { render, staticRenderFns } from "./ExcTwoSideBlockLayout.vue?vue&type=template&id=3e5d670c&scoped=true&"
import script from "./ExcTwoSideBlockLayout.vue?vue&type=script&lang=js&"
export * from "./ExcTwoSideBlockLayout.vue?vue&type=script&lang=js&"
import style0 from "./ExcTwoSideBlockLayout.vue?vue&type=style&index=0&id=3e5d670c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5d670c",
  null
  
)

export default component.exports